import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ProductCard from "../components/ProductCard";
import { api } from "../lib/api";

const SPANS = [
  "md:col-span-6 lg:col-span-7",
  "md:col-span-6 lg:col-span-5",
  "md:col-span-6 lg:col-span-5",
  "md:col-span-6 lg:col-span-7",
];

export default function FortnitePage() {
  const [products, setProducts] = useState([]);
  const [comingSoon, setComingSoon] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get("/products"), api.get("/coming-soon")])
      .then(([p, c]) => {
        setProducts(p.data.filter((x) => x.category === "fortnite"));
        setComingSoon(c.data.filter((x) => x.category === "Fortnite"));
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <Header />
      <section className="border-b border-[#FFD700]/20 bg-gradient-to-b from-[#0E0B02] to-transparent">
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-12 md:pt-28">
          <p className="af-mono text-[10px] uppercase tracking-[0.3em] text-[#FFD700] mb-4">
            // New drop
          </p>
          <h1
            className="af-display text-5xl md:text-7xl font-black uppercase tracking-tighter leading-[0.92]"
            data-testid="fortnite-title"
          >
            Fortnite
          </h1>
          <p className="text-zinc-400 mt-6 max-w-2xl">
            3D printed Fortnite collectibles — sprites, mythics and more, fresh
            off the print bed.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        {loading && (
          <p className="af-mono text-zinc-500 text-sm" data-testid="fortnite-loading">
            Loading the drop…
          </p>
        )}

        {products.length > 0 && (
          <div
            className="grid grid-cols-1 md:grid-cols-12 gap-6"
            data-testid="fortnite-available-grid"
          >
            {products.map((p, i) => (
              <ProductCard key={p.slug} product={p} span={SPANS[i % SPANS.length]} />
            ))}
          </div>
        )}

        {comingSoon.length > 0 && (
          <div className="mt-20" data-testid="fortnite-dropping-soon">
            <p className="af-mono text-[10px] uppercase tracking-[0.3em] text-[#FFD700] mb-3">
              // Dropping soon
            </p>
            <h2 className="af-display text-3xl md:text-4xl font-black uppercase tracking-tighter">
              Prices coming soon
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
              {comingSoon.map((c) => (
                <div
                  key={c.slug}
                  className="af-card overflow-hidden group"
                  data-testid={`fortnite-soon-${c.slug}`}
                >
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={c.image}
                      alt={c.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-start justify-between gap-3">
                      <h3 className="font-bold uppercase tracking-wide text-sm">
                        {c.name}
                      </h3>
                      <span className="af-mono text-[9px] uppercase tracking-[0.2em] text-[#FFD700] border border-[#FFD700]/30 px-2 py-1 whitespace-nowrap">
                        Price TBA
                      </span>
                    </div>
                    <p className="text-zinc-500 text-xs mt-2">{c.tagline}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
